export default __webpack_public_path__ + "static/media/illustration-health-1-w@3x.7642e5ba.png";